import { render, staticRenderFns } from "./PartnerHistory.vue?vue&type=template&id=5959c298&scoped=true&"
import script from "./PartnerHistory.vue?vue&type=script&lang=ts&"
export * from "./PartnerHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerHistory.vue?vue&type=style&index=0&id=5959c298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5959c298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
